import { generatePath } from 'react-router-dom';
import { MissedPaymentsPaths, PayPaths } from '../Constants/Common';

export const PaymentPagePath = `${PayPaths.Root}/${PayPaths.Payment}` as const;
export const MissedPaymentPagePath =
    `${MissedPaymentsPaths.Root}/${MissedPaymentsPaths.MissedPayment}` as const;
export const MissedPaymentSuccessPath =
    `${MissedPaymentsPaths.Root}/${MissedPaymentsPaths.MissedPayment}/${MissedPaymentsPaths.Success}` as const;

export const buildPaymentPagePath = (type: string, id: string) =>
    generatePath(PaymentPagePath, {
        id,
        type
    });

export const buildMissedPaymentPagePath = (policyReference: string) =>
    generatePath(MissedPaymentPagePath, {
        policyReference
    });

export const buildMissedPaymentSuccessPath = (policyReference: string) =>
    generatePath(MissedPaymentSuccessPath, {
        policyReference
    });
